/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    publicKey: z.string(),
    privateKey: z.string(),
    createdAt: z.coerce.date().default(() => new Date()),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    publicKey: z.string(),
    privateKey: z.string(),
    createdAt: z.coerce.date(),
}
).strict();

/**
 * `Jwks` schema excluding foreign keys and relations.
 */
export const JwksScalarSchema = baseSchema;


/**
 * `Jwks` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const JwksSchema = JwksScalarSchema;


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const JwksPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const JwksPrismaUpdateSchema = z.object({
    id: z.string(),
    publicKey: z.string(),
    privateKey: z.string(),
    createdAt: z.coerce.date()
}).partial().passthrough();


/**
 * `Jwks` schema for create operations excluding foreign keys and relations.
 */
export const JwksCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true
});


/**
 * `Jwks` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const JwksCreateSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true
});


/**
 * `Jwks` schema for update operations excluding foreign keys and relations.
 */
export const JwksUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Jwks` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const JwksUpdateSchema = JwksUpdateScalarSchema;

